/* DVR - A COLECAO LIDA COMO LOJA DE ROUPA, a parte que o CSS nao faz.
   (Claude, 27/09/2026)

   Quatro coisas, as quatro pequenas:

   1. A BARRA DE MODALIDADE SOBE. O dvr-vitrine2.js cria a barra dentro da
      secao da vitrine, o que a deixa abaixo da faixa do topo. Categoria em
      loja de roupa fica logo embaixo do cabecalho, entao ela muda de lugar no
      DOM. E so um insertBefore: os botoes continuam sendo os mesmos elementos,
      com os mesmos ouvintes, porque mover no DOM nao desliga evento nenhum.

   2. O NOME PERDE O PREFIXO. Todo titulo comeca com "Camisa", e o campo
      custom.nome_vitrine esta vazio nos 79. Com o nome cortado em uma linha,
      "Camisa" come os sete caracteres mais valiosos e a pessoa le "Camisa
      manual cogumelos do bosq...". Com a categoria no topo e o selo de
      modalidade no cartao, a palavra nao informa nada. O titulo do produto
      nao e alterado: so o texto do cartao.

   3. A FILA DE LOCAIS GANHA UM ROTULO. Ela fica onde o motor a criou, embaixo
      da peca, centralizada e com texto menor, que foi o pedido dele depois de
      recusar as duas tentativas anteriores (peca desenhada em 18 px, e a fila
      em pe por cima da foto). O que entra e uma palavra antes dos botoes:
      "Estampa:". Sem ela sao tres palavras soltas e a pessoa nao sabe do que
      falam. Ela divide a linha dos botoes, entao nao cobra altura.

   4. A MODALIDADE ENTRA PELA URL. Para o menu do tema poder abrir Vestuario
      em submenu, como ele ja abre todas as outras categorias, os filhos sao
      links comuns com ?mod=uni, ?mod=bab ou ?mod=ove.

   Nenhum motor foi tocado. Sem este arquivo, tudo volta ao que era.
*/
(function () {
'use strict';

/* ---- 0. a modalidade pode vir pela URL ----
   O menu do tema abre submenu em toda categoria, menos em Vestuario, que nao
   tem filhos. Os filhos sao links comuns na Navegacao da loja, e um link nao
   consegue mexer em localStorage: por isso ele diz a modalidade na propria
   URL, /collections/vestuario?mod=bab, e aqui ela entra na escolha.

   Isto roda na hora, fora do ciclo, e nao no DOMContentLoaded: o dvr-vitrine2.js
   le a chave quando executa, e executar e antes disso. Este arquivo e chamado
   no cabecalho e o motor no corpo, e defer mantem a ordem, entao chegamos
   primeiro. So a modalidade vem da URL; cor e local continuam sendo do visitante. */
(function () {
  var m = (location.search.match(/[?&]mod=([a-z]+)/i) || [])[1];
  if (!m) return;
  m = m.toLowerCase();
  if (m !== 'uni' && m !== 'bab' && m !== 'ove' && m !== 'mol') return;
  try {
    var a = {};
    try { a = JSON.parse(localStorage.getItem('dvr:vitrine2') || '{}') || {}; } catch (e) { a = {}; }
    if (!a || typeof a !== 'object') a = {};
    a.mod = m;
    localStorage.setItem('dvr:vitrine2', JSON.stringify(a));
  } catch (e) {}
})();

var PREFIXO = /^(camisas?|camisetas?|oversized|baby\s*look|moletom)\s+/i;

function encurta() {
  var nomes = document.querySelectorAll('.dv-nome');
  for (var i = 0; i < nomes.length; i++) {
    var n = nomes[i];
    if (n.getAttribute('data-dvr-curto')) continue;
    var cheio = (n.textContent || '').trim();
    if (!cheio) continue;
    var curto = cheio.replace(PREFIXO, '');
    n.setAttribute('data-dvr-curto', '1');
    if (!curto || curto === cheio) continue;
    /* primeira letra em caixa alta: "manual cogumelos" vira "Manual cogumelos" */
    curto = curto.charAt(0).toUpperCase() + curto.slice(1);
    /* o nome inteiro fica no title, para quem passa o mouse e para o leitor de tela */
    if (!n.getAttribute('title')) n.setAttribute('title', cheio);
    n.textContent = curto;
  }
}

function sobeBarra() {
  var barra = document.querySelector('.dv2-mods');
  if (!barra || barra.getAttribute('data-dvr-subiu')) return !!barra;
  /* a faixa do topo e achada pelo trilho dela, nao por id fixo de secao */
  var pista = document.querySelector('.vt-pista');
  var secao = pista && pista.closest ? pista.closest('[id^="shopify-section"]') : null;
  if (!secao || !secao.parentNode) return false;
  if (barra.parentNode === secao.parentNode && barra.nextElementSibling === secao) {
    barra.setAttribute('data-dvr-subiu', '1');
    return true;
  }
  secao.parentNode.insertBefore(barra, secao);
  barra.setAttribute('data-dvr-subiu', '1');
  return true;
}

/* ---- o cartao condensado: a fila de locais fica embaixo da peca ---- */
/* Duas tentativas minhas foram recusadas antes desta, e as duas com razao.
   Primeiro eu desenhei a peca em 18 px: viraram tres quadradinhos escuros.
   Depois eu joguei a fila em pe por cima da foto, do lado da roupa: ficou,
   nas palavras dele, "meio como se estivesse bugado". Estava mesmo. Etiqueta
   flutuando sobre a manga nao parece controle, parece sobra de render.

   Entao a fila volta para onde o motor a criou, embaixo da peca, com a
   palavra, e fica CENTRALIZADA e menor. O unico acrescimo e o rotulo, e ele
   entra na MESMA linha, antes dos tres botoes: "a pessoa so ve escrito frente
   peito costas, nao sei se ela entende o que significa". Sozinhas nao dizem
   mesmo. Com "Estampa:" na frente, a fila vira frase e nao custa altura
   nenhuma, porque divide a linha que ja existia.

   O texto e os ouvintes sao os mesmos que o motor criou: nada de recriar
   botao. */
var ONDE = { Frente: 'Estampa na frente', Peito: 'Estampa no peito', Costas: 'Estampa nas costas' };

function condensa() {
  var ctrls = document.querySelectorAll('.dv2-ctrl');
  for (var i = 0; i < ctrls.length; i++) {
    var ct = ctrls[i];
    if (ct.getAttribute('data-dvr-cond')) continue;
    var pos = ct.querySelector('.dv2-pos');
    if (!pos) continue;
    ct.setAttribute('data-dvr-cond', '1');
    var bts = pos.children;
    for (var j = 0; j < bts.length; j++) {
      var b = bts[j];
      var q = (b.getAttribute('data-pos') || b.textContent || '').trim();
      if (!ONDE[q]) continue;
      b.setAttribute('title', ONDE[q]);
      b.setAttribute('aria-label', ONDE[q]);
    }
    /* o rotulo na propria linha, antes do primeiro botao */
    var rot = document.createElement('span');
    rot.className = 'dvr-rot';
    rot.textContent = 'Estampa:';
    pos.insertBefore(rot, pos.firstChild);
  }
}

var tentativas = 0;
function ciclo() {
  encurta();
  condensa();
  var pronto = sobeBarra();
  /* a barra nasce por JavaScript, entao ela pode nao existir ainda. tenta por
     uns segundos e desiste sem quebrar nada se ela nunca aparecer. */
  if (!pronto && tentativas++ < 40) setTimeout(ciclo, 150);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ciclo);
else ciclo();
window.addEventListener('load', ciclo);

/* a vitrine repinta cartao ao filtrar e ao buscar: o nome de cartao novo
   tambem tem que encurtar. o marcador data-dvr-curto evita trabalho repetido. */
if (window.MutationObserver) {
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { encurta(); condensa(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
}
})();